export enum EProjectTwcGeRequestApplicationType {
  TWC = 1,
  GE = 2,
}

export enum EProjectTwcGeRequestStatus {
  INITIAL = 'IN',
  CANCELLED = 'CN',
  WAITING_FOR_PM = 'WP',
  REJECTED_BY_PM = 'RP',
  WAITING_FOR_EM = 'WE',
  REJECTED_BY_EM = 'RE',
  WAITING_FOR_HOE = 'WH',
  REJECTED_BY_HOE = 'RH',
  COMPLETED = 'CD',
  DRAFT = 'DR',
  REVOKE = 'RV',
}
